<template>
  <div class="gap-[20px]">
    <div
      class="relative w-full h-[300px] sm:h-[400px] md:h-[500px] rounded-[16px] overflow-hidden"
    >
      <!-- Image Section -->
      <img
        class="absolute inset-0 w-full h-full object-cover"
        :src="img"
        alt=""
      />

      <!-- Content Section with Flex Layout -->
      <div
        class="relative z-10 flex flex-col md:flex-row items-center md:items-end h-full p-6 md:p-8 text-white"
      >
        <!-- Left Side: Title and Description -->
        <div class="w-full lg:w-1/2 space-y-4 text-center md:text-left">
          <h1
            class="text-[24px] md:text-[36px] lg:text-[40px] font-semibold leading-tight"
          >
            {{ title }}
          </h1>
          <p class="text-[16px] leading-relaxed">
            {{ detailed }}
          </p>
        </div>

        <!-- Right Side: Button -->
        <div
          class="w-full md:w-1/2 flex justify-center md:justify-end mt-6 md:mt-0"
        >
          <a
            :href="route"
            class="bg-tbt-blue text-white rounded-full px-4 py-2 md:px-8 md:py-3 text-sm md:text-base hover:scale-105 transition-transform duration-300 focus:outline-none"
          >
            {{ getLocalized1("title") }}
          </a>
        </div>
      </div>

      <!-- Overlay for Contrast -->
      <div
        class="absolute inset-0 bg-gradient-to-b from-black via-transparent to-black opacity-50"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detailed: { type: String },
    title: { type: String, required: true },
    img: { type: String, required: true },
    route: { type: String, required: true },
  },
  data() {
    return {
      translations: {
        title: {
          en: "Explore Now",
          kh: "ព័ត៌មានលម្អិតបន្ថែម",
        },
      },
      currentLang: localStorage.getItem("language") || "en",
    };
  },
  computed: {
    getLocalized1() {
      return (key) => {
        return this.translations[key]
          ? this.translations[key][this.currentLang]
          : key;
      };
    },
  },
};
</script>
